import { C } from "./const";
import SectionBadge from "./IntroSectionBadge";
import SectionTitle from "./IntroSectionTitle";

export const SERVICES = [
    { icon: "🚗", title: "بیمه خودرو", desc: "پوشش کامل شخص ثالث و بدنه خودرو با بهترین نرخ بازار" },
    { icon: "🏥", title: "بیمه درمان", desc: "پوشش هزینه‌های بستری، جراحی و دندانپزشکی" },
    { icon: "🏠", title: "بیمه آتش‌سوزی", desc: "حفاظت از منزل و اموال در برابر حوادث غیرمترقبه" },
    { icon: "✈️", title: "بیمه مسافرتی", desc: "پوشش کامل سفرهای داخلی و خارجی" },
    { icon: "💼", title: "بیمه عمر", desc: "سرمایه‌گذاری بلندمدت همراه با پوشش بیمه عمر" },
    { icon: "🏗️", title: "بیمه مسئولیت", desc: "پوشش مسئولیت مدنی حرفه‌ای و کارفرمایی" },
];

const IntroServices = () => {
    return (

        <section id="services" style={{ background: C.neutralLight, padding: "80px 24px" }}>
            <div style={{ maxWidth: 1200, margin: "0 auto" }}>
                <div style={{ textAlign: "center", marginBottom: 52 }}>
                    <SectionBadge text="خدمات ما" />
                    <SectionTitle center>انواع پوشش‌های بیمه‌ای</SectionTitle>
                    <p style={{ color: C.gray, fontSize: 16, maxWidth: 560, margin: "0 auto", lineHeight: 1.8 }}>
                        طیف گسترده‌ای از خدمات بیمه‌ای با بهترین نرخ و سریع‌ترین خدمات پس از فروش
                    </p>
                </div>

                <div
                    className="grid-3"
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(3,1fr)",
                        gap: 26,
                    }}
                >
                    {SERVICES.map((s) => (
                        <div
                            key={s.title}
                            className="hov-lift"
                            style={{
                                background: C.white,
                                borderRadius: 18,
                                padding: 30,
                                boxShadow: "0 4px 20px rgba(0,86,179,.07)",
                                border: `1px solid ${C.border}`,
                                cursor: "default",
                            }}
                        >
                            <div
                                style={{
                                    width: 60,
                                    height: 60,
                                    background: C.primaryLight,
                                    borderRadius: 14,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: 26,
                                    marginBottom: 18,
                                }}
                            >
                                {s.icon}
                            </div>
                            <h3
                                style={{
                                    fontSize: 17,
                                    fontWeight: 700,
                                    color: C.primaryDark,
                                    marginBottom: 8,
                                }}
                            >
                                {s.title}
                            </h3>
                            <p style={{ color: C.gray, fontSize: 14, lineHeight: 1.75, marginBottom: 18 }}>
                                {s.desc}
                            </p>
                            <a
                                href="#contact"
                                style={{
                                    color: C.primary,
                                    fontSize: 13,
                                    fontWeight: 700,
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 4,
                                }}
                            >
                                استعلام قیمت ←
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </section>

    );
}







export default IntroServices;